import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { identity, isEmpty, noop } from 'lodash'

import { FormLabel } from 'carbon-components-react'
import { PageFirst32, PageLast32 } from '@carbon/icons-react'

import { Button } from '../../Button'
import { OverflowMenu, OverflowMenuItem } from '../../OverflowMenu'

const ToggleButton = React.memo(
  ({ isExpanded, onClick, openLabel, closeLabel }) => (
    <Button
      className='toggle-filter-bar'
      size='default'
      kind='ghost'
      renderIcon={isExpanded ? PageLast32 : PageFirst32}
      iconDescription={isExpanded ? closeLabel : openLabel}
      tooltipPosition='bottom'
      tooltipAlignment='center'
      hasIconOnly
      onClick={onClick}
    />
  )
)

const Header = ({
  t,
  isExpanded,
  toggleFilterBar,
  onReset= noop,
  onReload = noop,
  isActiveFiltersOpened,
  onToggleFilters,
  servicesConfig
}) => {
  const { filterList, saveFilter } = servicesConfig

  return isExpanded ? (
    <Fragment>
      <FormLabel className='filter-bar-title'>{t('FILTERS_TITLE')}</FormLabel>
      <ToggleButton
        openLabel={t('OPEN')}
        closeLabel={t('CLOSE')}
        isExpanded={isExpanded}
        onClick={toggleFilterBar}
      />
      <OverflowMenu className='toggle-filter-menu' flipped direction='bottom'>
        {!isEmpty(servicesConfig) && (
          <OverflowMenuItem itemText={t('MY_FILTERS')} onClick={filterList} />
        )}
        {!isEmpty(servicesConfig) && (
          <OverflowMenuItem
            itemText={t('SAVE_NEW_FILTER')}
            onClick={saveFilter}
          />
        )}
        {/* <OverflowMenuItem
          onClick={onReload}
          itemText={t('RELOAD')}
          hasDivider={!isEmpty(servicesConfig)}
        /> */}
        <OverflowMenuItem
          itemText={
            isActiveFiltersOpened
              ? t('TOGGLE_FILTERS_CLOSE')
              : t('TOGGLE_FILTERS_OPEN')
          }
          onClick={onToggleFilters}
        />
        {/* <OverflowMenuItem
          isDelete
          hasDivider
          itemText={t('RESET')}
          onClick={onReset}
        /> */}
      </OverflowMenu>
    </Fragment>
  ) : (
    <Fragment>
      <ToggleButton
        openLabel={t('OPEN')}
        closeLabel={t('CLOSE')}
        isExpanded={isExpanded}
        onClick={toggleFilterBar}
      />
      <FormLabel className='filter-bar-title close'>
        {t('FILTERS_TITLE')}
      </FormLabel>
    </Fragment>
  )
}

Header.propTypes = {
  t: PropTypes.func,
  isExpanded: PropTypes.bool,
  toggleFilterBar: PropTypes.func,
  onReset: PropTypes.func,
  onReload: PropTypes.func,
  isActiveFiltersOpened: PropTypes.bool,
  onToggleFilters: PropTypes.func
}

Header.defaultProps = {
  t: identity,
  isExpanded: false,
  toggleFilterBar: identity,
  onReset: identity,
  onReload: identity,
  isActiveFiltersOpened: false,
  onToggleFilters: identity
}

export default React.memo(Header)
